import { Controller } from '@hotwired/stimulus';
import { visitPlayerScreen } from '../lib/player_screen_navigation.js';

export default class extends Controller {
  select(event) {
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    if (this.navigating) return;
    this.navigating = true;
    visitPlayerScreen(event.currentTarget.href);
  }
}
